import { eventTracker } from '@hakimo-ui/hakimo/util';
import { Button } from '@hakimo-ui/shared/ui-base';
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
} from '@heroicons/react/24/solid';

interface Props {
  count: number;
  fetchAlarm: () => void;
  isLoading: boolean;
}

export function MonitoringScreen(props: Props) {
  const { count, fetchAlarm, isLoading } = props;
  return (
    <div className="flex h-full flex-col items-center justify-center">
      {count === 0 && (
        <>
          <CheckCircleIcon className="text-status-green max-h-[24rem]" />
          <div className="text-onlight-text-2 dark:text-ondark-text-2 mt-4 text-6xl">
            No pending alarms!
          </div>
        </>
      )}

      {count > 0 && (
        <>
          <ExclamationCircleIcon className="text-status-red max-h-[24rem] motion-safe:animate-bounce" />
          <div className="text-onlight-text-2 dark:text-ondark-text-2 mt-4 text-4xl">
            {String(count)} alarms pending
          </div>
          <div className="mt-6 rounded-md">
            <Button
              variant="primary"
              onClick={fetchAlarm}
              loading={isLoading}
              disabled={isLoading}
              onSideEffect={eventTracker('get_monitoring_alarm')}
            >
              <div className="text-6xl">Get alarm</div>
            </Button>
          </div>
        </>
      )}
    </div>
  );
}
